module.exports = __webpack_public_path__ + "static/media/Icon_menu_search_white.d42e08f8.svg";